import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const AngleRight = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.89999 17.2C9.29999 17.2 8.89999 16.8 8.89999 16.2C8.89999 15.9 8.99999 15.7 9.19999 15.5L12.7 12L9.19999 8.5C8.79999 8.1 8.79999 7.5 9.19999 7.1C9.59999 6.7 10.2 6.7 10.6 7.1L14.8 11.3C15.2 11.7 15.2 12.3 14.8 12.7L10.6 16.9C10.4 17.1 10.1 17.2 9.89999 17.2Z"
      fill="currentColor"
    />
  </svg>
)

export default AngleRight
